export default {
  name: "restructure selection",
  applyToVersions: "<=2.0.4",
  type: "before",
  migrate(data) {
    if (!data.selection) return data;

    if (data.selection.fixedSelected) {
      delete data.selection.fixedSelected;
    }

    if (!data.selection.selected) return data;

    const selectedBefore = data.selection.selected || [];

    if (selectedBefore.element) {
      return data;
    }

    data.selection.selected = {
      element: selectedBefore
        .filter((item) => item.type === "element")
        .map((item) => item.id),
      resource: selectedBefore
        .filter((item) => item.type === "resource")
        .map((item) => item.id),
      relation: selectedBefore
        .filter((item) => item.type === "relation")
        .map((item) => item.id),
      elementResource: selectedBefore
        .filter((item) => item.type === "elementResource")
        .map((item) => item.id),
      question: selectedBefore
        .filter((item) => item.type === "question")
        .map((item) => item.id)
    };

    return data;
  }
};
